export function resolveTypingUserName(user, t) {
  const name = String(user?.userName || "").trim();
  if (name) return name;
  const id = user?.userId;
  if (id != null && id !== "") {
    return t("typingUserFallback", { id });
  }
  return t("typingSomeone");
}

export function buildTypingLabel(typingUsers, t) {
  if (!typingUsers?.length) return "";
  const names = typingUsers.map((user) => resolveTypingUserName(user, t));
  if (names.length === 1) return t("typingOne", { name: names[0] });
  if (names.length === 2) return t("typingTwo", { name1: names[0], name2: names[1] });
  return t("typingMany");
}
